import { Link } from 'react-router-dom';
import { useCurrencySymbol } from '@shared/hooks';
import { FormatUtils, RoutePaths } from '@shared/utils';
import type { CardResponse } from '@shared/api/rest/cards';
import { Button, ColorsEnum, Icon, Text } from '@shared/widgets';
import VisaIcon from '@assets/icons/card/visa.svg';
import TrashIcon from '@assets/icons/trash.svg';
import { useState } from 'react';
import { AccountType } from '@shared/api/rest/accounts';
import { ModalDeleteConfirmation } from '../modals';

export interface ISmallCardProps {
  card: CardResponse;
  removeCard: (id: number) => void;
}

export const SmallCard = (props: ISmallCardProps) => {
  const [isViewModal, setIsViewModal] = useState<boolean>(false);
  const symbol = useCurrencySymbol(props.card.currency);

  return (
    <>
      <div className='mb-6 pb-6 flex items-center border-b border-b-gray-black last:border-none last:mb-0 last:pb-0'>
        <Link
          className='w-16 h-10 mr-4 rounded-lg bg-soft-black dark:bg-gray-wet-asphalt flex-none flex items-center justify-center text-center'
          to={RoutePaths.card.onNavigate(props.card.cardId)}
        >
          <Icon icon={<VisaIcon />} color='white' />
        </Link>
        <div className='min-w-0 pr-3 flex-auto'>
          <Text className='text-ellipsis overflow-hidden' weight='medium' size='xs' color={ColorsEnum.Secondary} isUppercase>
            {FormatUtils.toSliceNumber(props.card.cardNumber)}
          </Text>
          <Text className='text-ellipsis overflow-hidden' weight='medium'>
            {symbol}
            {props.card.balance}
          </Text>
        </div>
        <Button color='icon' onClick={() => setIsViewModal(true)}>
          <Icon icon={<TrashIcon />} />
        </Button>
      </div>
      {isViewModal && (
        <ModalDeleteConfirmation onClose={() => setIsViewModal(false)} type={AccountType.Card} onDelete={props.removeCard} id={props.card.cardId} />
      )}
    </>
  );
};
